import {
  imprimirServicoAntigo,
  imprimirServicoNovo,
  buscarDadosImpressao,
} from '../utils';
import adapter from './adapter';
import layout from './layout';
import { imprimirNotaPreVenda} from 'modulo-gerencial-erp-pacotes-impressora-termica'

async function imprimir(id, query = '', usar_nova_impressao = false) {
/*   if (!usar_nova_impressao) {
    return await imprimirServicoAntigo(id, 4, query);
  }

  const dados = await buscarDadosImpressao(id, 4);

  const { comandos } = layout(adapter(dados));

  const response = await imprimirServicoNovo(id, 'nota-pre-venda', comandos);
  return response.data; */

  return await imprimirNotaPreVenda({id, buscarDadosImpressao, chamarServicoImpressoraTermica: imprimirServicoNovo, query: ''})
}

export default imprimir;